const paletteMapper = Object.freeze({
  PALSCHEME_GRAYSCALE: 'Grayscale',
  PALSCHEME_GRAYSCALE_INVERTED: 'Grayscale Inverted',
  PALSCHEME_BLUERED: 'Blue Red',
  PALSCHEME_HIGHCONTRAST: 'High Contrast',
  PALSCHEME_HOTMETAL: 'Hot Metal',
  PALSCHEME_IRONBOW: 'Ironbow',
  PALSCHEME_AMBER: 'Amber',
  PALSCHEME_AMBER_INVERTED: 'Amber Inverted',
  PALSCHEME_RAINBOW: 'Rainbow',
  PALSCHEME_RAINBOW900: 'Rainbow 900',
  PALSCHEME_GLOWBOW: 'Glow Bow',
  // PALSCHEME_HIGH_CONTRAST_VT: 'High Contrast VT', // broken
  // PALSCHEME_RAINBOW_VT: 'Rainbow VT', // broken
  PALSCHEME_IRONBOW_VT: 'Ironbow VT',
  PALSCHEME_HOTMETAL_VT: 'Hot Metal VT',
  PALSCHEME_PHANTOM_BLRED: 'Phantom Blue Red',
  PALSCHEME_PHANTOM_VBW: 'Phantom VBW',
  PALSCHEME_PHANTOM_VVARIO: 'Phantom V Vario',
  PALSCHEME_PHANTOM_RAINBOW: 'Phantom Rainbow',
  PALSCHEME_PHANTOM_STUF10: 'Phantom STUF10',
  PALSCHEME_PHANTOM_BKRED: 'Phantom BK Red',
  PALSCHEME_PHANTOM_FIRE: 'Phantom Fire',
  PALSCHEME_PHANTOM_MENTHOL: 'Phantom Menthol',
  PALSCHEME_PHANTOM_SEPIA: 'Phantom Sepia',
  PALSCHEME_PHANTOM_SWVARIO: 'Phantom SW Vario',
  PALSCHEME_MUSE_GRAYSCALE: 'Muse Grayscale',
  PALSCHEME_MUSE_HOTMETAL: 'Muse Hot Metal',
  PALSCHEME_MUSE_IRONBOW: 'Muse Ironbow',
  PALSCHEME_PHANTOM_VIRON: 'Phantom Viron',
});

export default paletteMapper;
